// extracted by mini-css-extract-plugin
export default {"capital":"index_capital_hQqb5"};